import { IIssueFrontSelection } from '../interfaces/issue.front.selection';

export class IssueFrontSelection implements IIssueFrontSelection {
    selection: boolean;
    id: number;
}
